export default [
  {
    path: '/',
    name: '主页',
    component: () => import('@/views/portal/Index')
  },
  {
    path: '/icf',
    name: '上传知情同意书',
    component: () => import('@/views/h5/informed-consent-form/index')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/api/sso',
    name: 'sso单点登录',
    component: () => import('@/views/api/sso')
  },
  {
    path: '/api/test',
    name: 'sso单点登录test',
    component: () => import('@/views/api/test')
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
  {
    path: '/home/disease-select',
    name: '病种选择',
    component: () => import('@/views/home/disease-select')
  }
]



// WEBPACK FOOTER //
// ./src/router/base.js